<template>
  <div class="navbar">
    <!-- 控制左侧sidebar打开的 此项目不需要 -->
    <hamburger :is-active="sidebar.opened"
               class="hamburger-container"
               @toggleClick="toggleSideBar" />

    <breadcrumb class="breadcrumb-container" />
    <!--  -->
    <div class="right-menu">
      <i class="el-icon-user-solid right-menu-item" />
      <div class="user-name right-menu-item">{{ name }}</div>
      <i class="el-icon-switch-button right-menu-item"
         @click="logout" />
      <!-- <span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span> -->
    </div>
    <!-- 跟此项目不符 -->
    <!-- <div class="right-menu">
        <template v-if="device!=='mobile'">

            <error-log class="errLog-container right-menu-item hover-effect" />

            <screenfull class="right-menu-item hover-effect" />

            <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
                <size-select class="right-menu-item hover-effect" />
            </el-tooltip>

            <lang-select class="right-menu-item hover-effect" />

        </template>

        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
            <div class="avatar-wrapper">
                <img :src="avatar ? $publicData.imgUrl + avatar + '?imageView2/1/w/80/h/80' : require('@/assets/images/default_avatar.jpg?imageView2/1/w/80/h/80')" class="user-avatar">
                <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
                <router-link to="/">
                    <el-dropdown-item>
                        {{ $t('navbar.dashboard') }}
                    </el-dropdown-item>
                </router-link>
                <router-link to="/user/my">
                    <el-dropdown-item>
                        {{ $t('route.my') }}
                    </el-dropdown-item>
                </router-link>
                <el-dropdown-item divided>
                    <span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div> -->
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import LangSelect from '@/components/LangSelect'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    LangSelect
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar',
      'device'
    ])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 64px;
  overflow: hidden;
  position: relative;
  background: #e70012;
  box-shadow: 0px 10px 16px 0px rgba(0, 34, 82, 0.35);

  .hamburger-container {
    line-height: 64px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #ffffff;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
    .right-menu-item.user-name {
      font-size: 13px;
      padding-left: 0;
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
